import type { ChartProps, TData } from "../types";

/**
 * Applies a `data`-type variable's 2D matrix to a chart's whole grid: row 0 is
 * the header row (series names), column 0 the category titles, exactly the
 * shape the Edit-data sheet edits (`normalizeData` fills any blanks). Mirrors
 * the table's parseTableDataDynamicVar; the static-library copy must match.
 */
export const parseChartDataDynamicVar = ({
  settings,
  matrix,
}: {
  settings: ChartProps;
  matrix: unknown;
}): ChartProps => {
  if (!Array.isArray(matrix) || matrix.length === 0) return settings;
  const rows = matrix.filter((row): row is unknown[] => Array.isArray(row));
  if (!rows.length) return settings;
  const data: TData = rows.map((row) =>
    row.map((cell) => ({ value: cell == null ? "" : String(cell) })),
  );
  return { ...settings, data };
};

/** `{{name}}` → `name` (the binding keeps its braces so the fs-vars manifest scan finds it). */
export const chartDataDynamicVariableName = (token: string): string =>
  token
    .replace(/^\{\{+/, "")
    .replace(/\}\}+$/, "")
    .trim();
